module.exports = __webpack_public_path__ + "img/S_8995_my-qiagen.5ad2666b.jpg";